import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface EditConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSaveAndContinue: () => Promise<void>;
  isSaving: boolean;
}

export const EditConfirmationModal = ({
  isOpen,
  onClose,
  onSaveAndContinue,
  isSaving,
}: EditConfirmationModalProps) => {
  const { t } = useTranslation("reportsv2/condensed_report");

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="edit-confirmation-dialog-title"
      aria-describedby="edit-confirmation-dialog-description"
    >
      <DialogTitle id="edit-confirmation-dialog-title">
        {t("edit_confirmation_title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="edit-confirmation-dialog-description">
          {t("edit_confirmation_description")}
        </DialogContentText>
        <DialogContentText sx={{ mt: 2 }}>
          {t("edit_confirmation_question")}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "16px",
        }}
      >
        <Button
          onClick={onClose}
          color="secondary"
          variant="outlined"
          disabled={isSaving}
        >
          {t("cancel")}
        </Button>
        <LoadingButton
          onClick={onSaveAndContinue}
          color="primary"
          variant="contained"
          loading={isSaving}
          disabled={isSaving}
        >
          {t("save_and_continue")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
